import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

const EMAIL_REGEXP = /^\S+@\S{2,}\.[a-z0-9-]{2,63}$/i

export class PaiValidators {
  static requiredString: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    return typeof control.value === 'string' && control.value.trim().length > 0 ? null : { required: true }
  }

  /**
   * Basically the angular Validators.email but with a different Regex.
   * less strict regarding the used chars but enforcing a TLD
   */
  static email: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (typeof control.value !== 'string') {
      return null // don't validate empty values to allow optional controls
    }
    return EMAIL_REGEXP.test(control.value) ? null : { email: true }
  }
}
